export default __webpack_public_path__ + "static/media/warning-banner.b9ab451e.svg";